// snapPointsPresets.js
// Пресеты точек привязки для различных типов фитингов

/**
 * Стандартные 8 точек (4 угла + 4 середины сторон)
 */
export const standardSnapPoints = [
  { x: 0, y: 0, relative: true },       // top-left
  { x: 1, y: 0, relative: true },       // top-right
  { x: 0, y: 1, relative: true },       // bottom-left
  { x: 1, y: 1, relative: true },       // bottom-right
  { x: 0.5, y: 0, relative: true },     // top-middle
  { x: 0.5, y: 1, relative: true },     // bottom-middle
  { x: 0, y: 0.5, relative: true },     // left-middle
  { x: 1, y: 0.5, relative: true },     // right-middle
];

/**
 * Для отводов (L-образная форма, 90°)
 * Основные точки соединения на концах отвода
 */
export const otvodSnapPoints = [
  // Верхний конец (вертикальная часть)
  { x: 0.5, y: 0, relative: true },     // верхний центр
  { x: 0, y: 0, relative: true },       // верхний левый угол
  { x: 1, y: 0, relative: true },       // верхний правый угол
  
  // Правый конец (горизонтальная часть)
  { x: 1, y: 0.5, relative: true },     // правый центр
  { x: 1, y: 0, relative: true },       // правый верхний угол (дубль, но важная точка)
  { x: 1, y: 1, relative: true },       // правый нижний угол
  
  // Внутренний угол отвода (место сгиба)
  { x: 0, y: 1, relative: true },       // внутренний угол
  
  // Дополнительные точки для удобства
  { x: 0, y: 0.5, relative: true },     // левая середина
  { x: 0.5, y: 1, relative: true },     // нижняя середина
  
  // Центральная точка сгиба (по диагонали)
  { x: 0.5, y: 0.5, relative: true },   // центр
];

/**
 * Для переходов концентрических (конусообразная форма)
 * Точки на обоих концах перехода
 */
export const perehodSnapPoints = [
  // Широкий конец (левая сторона)
  { x: 0, y: 0, relative: true },       // top-left
  { x: 0, y: 0.5, relative: true },     // left-middle
  { x: 0, y: 1, relative: true },       // bottom-left
  
  // Узкий конец (правая сторона)
  { x: 1, y: 0.25, relative: true },    // узкий конец верх
  { x: 1, y: 0.5, relative: true },     // узкий конец центр
  { x: 1, y: 0.75, relative: true },    // узкий конец низ
  
  // Середина перехода
  { x: 0.5, y: 0, relative: true },     // top-middle
  { x: 0.5, y: 0.5, relative: true },   // center
  { x: 0.5, y: 1, relative: true },     // bottom-middle
];

/**
 * Для бортшайб (круглые фитинги)
 * Центр + точки по кругу + точки на краях прямоугольника
 */
export const bortshaіbaSnapPoints = [
  // Центр (самая важная точка)
  { x: 0.5, y: 0.5, relative: true },   // center
  
  // Основные направления (север, юг, запад, восток)
  { x: 0.5, y: 0, relative: true },     // top
  { x: 0.5, y: 1, relative: true },     // bottom
  { x: 0, y: 0.5, relative: true },     // left
  { x: 1, y: 0.5, relative: true },     // right
  
  // Диагональные направления (для более точной привязки)
  { x: 0, y: 0, relative: true },       // top-left corner
  { x: 1, y: 0, relative: true },       // top-right corner
  { x: 0, y: 1, relative: true },       // bottom-left corner
  { x: 1, y: 1, relative: true },       // bottom-right corner
  
  // Дополнительные точки на окружности (под углами 45°)
  { x: 0.146, y: 0.146, relative: true }, // ~45° (cos(45°) ≈ 0.854, отступ 0.146)
  { x: 0.854, y: 0.146, relative: true }, // ~45°
  { x: 0.146, y: 0.854, relative: true }, // ~45°
  { x: 0.854, y: 0.854, relative: true }, // ~45°
];

/**
 * Упрощенная версия для бортшайб (только 5 точек)
 */
export const bortshaіbaSimpleSnapPoints = [
  { x: 0.5, y: 0.5, relative: true },   // center
  { x: 0.5, y: 0, relative: true },     // top
  { x: 0.5, y: 1, relative: true },     // bottom
  { x: 0, y: 0.5, relative: true },     // left
  { x: 1, y: 0.5, relative: true },     // right
];

/**
 * Для круглых фитингов малого размера (только 4 точки)
 */
export const roundSmallSnapPoints = [
  { x: 0.5, y: 0, relative: true },     // top
  { x: 0.5, y: 1, relative: true },     // bottom
  { x: 0, y: 0.5, relative: true },     // left
  { x: 1, y: 0.5, relative: true },     // right
];

/**
 * Для фланцев (похожи на бортшайбы, но с акцентом на болтовые отверстия)
 */
export const flanecSnapPoints = [
  { x: 0.5, y: 0.5, relative: true },   // center (для соосности)
  { x: 0.5, y: 0, relative: true },     // top
  { x: 0.5, y: 1, relative: true },     // bottom
  { x: 0, y: 0.5, relative: true },     // left
  { x: 1, y: 0.5, relative: true },     // right
];

// ═══════════════════════════════════════════════════════════════
// ПРЕСЕТЫ С АБСОЛЮТНЫМИ КООРДИНАТАМИ В ММ
// ═══════════════════════════════════════════════════════════════
// Эти пресеты используют точные координаты в миллиметрах.
// Они НЕ масштабируются автоматически, поэтому подходят только
// для фитингов с фиксированными размерами.
// ═══════════════════════════════════════════════════════════════

/**
 * Создаёт точки для отвода с абсолютными координатами в мм
 * Отводы имеют квадратную форму (size x size), L-образную геометрию
 * 
 * @param {number} size - размер отвода (diameter и length равны, например 70x70)
 * @returns {Array} массив точек привязки
 */
export const createOtvodAbsoluteSnapPoints = (size) => [
  // Верхний конец (вертикальная часть)
  { x: size, y: 0, absolute: true },               // правая верхняя точка
  
  // Правый конец (горизонтальная часть)
  { x: size, y: size / 2, absolute: true },        // правая нижняя точка
  
  // Внутренний угол отвода (место сгиба)
  { x: 0, y: size, absolute: true },               // нижняя левая точка
  
  // Дополнительные точки
  { x: size / 2, y: size, absolute: true },        // нижняя правая точка
];

/**
 * Создаёт точки для перехода с абсолютными координатами в мм
 * Переходы имеют коническую форму
 * 
 * @param {number} diameter - наружный диаметр широкого конца
 * @param {number} length - длина перехода
 * @returns {Array} массив точек привязки
 */
export const createPerehodAbsoluteSnapPoints = (diameter, length) => [
  // Широкий конец (левая сторона) - весь диаметр
  { x: 0, y: 0, absolute: true },                  // top-left
  { x: 0, y: diameter / 2, absolute: true },       // left-middle - главная точка
  { x: 0, y: diameter, absolute: true },           // bottom-left
  
  // Узкий конец (правая сторона) - примерно 25% диаметра от края
  { x: length, y: diameter * 0.25, absolute: true },    // узкий конец верх
  { x: length, y: diameter * 0.5, absolute: true },     // узкий конец центр - главная точка
  { x: length, y: diameter * 0.75, absolute: true },    // узкий конец низ
  
  // Середина перехода
  { x: length / 2, y: 0, absolute: true },              // top-middle
  { x: length / 2, y: diameter / 2, absolute: true },   // center
  { x: length / 2, y: diameter, absolute: true },       // bottom-middle
];

/**
 * Создаёт точки для бортшайбы с абсолютными координатами в мм
 * Бортшайбы - круглые фитинги
 * 
 * @param {number} diameter - наружный диаметр бортшайбы
 * @param {number} length - толщина бортшайбы
 * @returns {Array} массив точек привязки (5 точек)
 */
export const createBortshaіbaAbsoluteSnapPoints = (diameter, length) => [
  { x: diameter / 2, y: length / 2, absolute: true },   // center - главная точка!
  { x: diameter / 2, y: 0, absolute: true },            // top
  { x: diameter / 2, y: length, absolute: true },       // bottom
  { x: 0, y: length / 2, absolute: true },              // left
  { x: diameter, y: length / 2, absolute: true },       // right
];

// ═══════════════════════════════════════════════════════════════
// ИНДИВИДУАЛЬНЫЕ ТОЧКИ ДЛЯ КАЖДОГО ОТВОДА (координаты в мм)
// ═══════════════════════════════════════════════════════════════

export const otvod20SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 51, y: 0, absolute: true },                   // [1] top-right угол
  { x: 0, y: 51, absolute: true },                   // [2] bottom-left угол
  { x: 51, y: 51, absolute: true, hidden: true },    // [3] bottom-right угол (скрытая)
  { x: 26.9, y: 0, absolute: true, hidden: true },   // [4] TOP-MIDDLE (скрытая)
  { x: 26.9, y: 51, absolute: true },                // [5] BOTTOM-MIDDLE
  { x: 0, y: 26.9, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 51, y: 26.9, absolute: true },                // [7] RIGHT-MIDDLE 
  { x: 13.45, y: 51, absolute: true },                // [8] Down-MIDDLE-F
  { x: 51, y: 13.45, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod25SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 55, y: 0, absolute: true },                   // [1] top-right угол
  { x: 0, y: 55, absolute: true },                   // [2] bottom-left угол
  { x: 55, y: 55, absolute: true, hidden: true },    // [3] bottom-right угол (скрытая)
  { x: 33.7, y: 0, absolute: true, hidden: true },     // [4] TOP-MIDDLE (скрытая)
  { x: 33.7, y: 55, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 33.7, absolute: true, hidden: true },     // [6] LEFT-MIDDLE (скрытая)
  { x: 55, y: 33.7, absolute: true },                  // [7] RIGHT-MIDDLE
  { x: 16.85, y: 55, absolute: true },                // [8] Down-MIDDLE-F
  { x: 55, y: 16.85, absolute: true },                // [9] RIGHT-MIDDLE-F
];

// Отвод Ду25 под трубу 32 мм. Габарит DXF 50×50, наружный диаметр трубы 32, ось 16.
export const otvod25_32mmSnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 50, y: 0, absolute: true },                   // [1] top-right угол
  { x: 0, y: 50, absolute: true },                   // [2] bottom-left угол
  { x: 50, y: 50, absolute: true, hidden: true },    // [3] bottom-right угол (скрытая)
  { x: 32, y: 0, absolute: true, hidden: true },     // [4] TOP-MIDDLE (скрытая)
  { x: 32, y: 50, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 32, absolute: true, hidden: true },     // [6] LEFT-MIDDLE (скрытая)
  { x: 50, y: 32, absolute: true },                  // [7] RIGHT-MIDDLE
  { x: 16, y: 50, absolute: true },                  // [8] Down-MIDDLE-F
  { x: 50, y: 16, absolute: true },                  // [9] RIGHT-MIDDLE-F
];

export const otvod32SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },     // [0] top-left угол (скрытая)
  { x: 70, y: 0, absolute: true },                  // [1] top-right угол
  { x: 0, y: 70, absolute: true },                  // [2] bottom-left угол
  { x: 70, y: 70, absolute: true, hidden: true },   // [3] bottom-right угол (скрытая)
  { x: 42.4, y: 0, absolute: true, hidden: true },    // [4] TOP-MIDDLE (скрытая)
  { x: 42.4, y: 70, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 42.4, absolute: true, hidden: true },    // [6] LEFT-MIDDLE (скрытая)
  { x: 70, y: 42.4, absolute: true },                 // [7] RIGHT-MIDDLE
  { x: 21.2, y: 70, absolute: true },                // [8] Down-MIDDLE-F
  { x: 70, y: 21.2, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod40SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 81, y: 0, absolute: true },                   // [1] top-right угол
  { x: 0, y: 81, absolute: true },                   // [2] bottom-left угол
  { x: 81, y: 81, absolute: true, hidden: true },    // [3] bottom-right угол (скрытая)
  { x: 48.3, y: 0, absolute: true, hidden: true },   // [4] TOP-MIDDLE (скрытая)
  { x: 48.3, y: 81, absolute: true },                // [5] BOTTOM-MIDDLE
  { x: 0, y: 48.3, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 81, y: 48.3, absolute: true },                // [7] RIGHT-MIDDLE
  { x: 24.15, y: 81, absolute: true },                // [8] Down-MIDDLE-F
  { x: 81, y: 24.15, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod50SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 105, y: 0, absolute: true },                  // [1] top-right угол
  { x: 0, y: 105, absolute: true },                  // [2] bottom-left угол
  { x: 105, y: 105, absolute: true, hidden: true },  // [3] bottom-right угол (скрытая)
  { x: 60.3, y: 0, absolute: true, hidden: true },     // [4] TOP-MIDDLE (скрытая)
  { x: 60.3, y: 105, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 60.3, absolute: true, hidden: true },     // [6] LEFT-MIDDLE (скрытая)
  { x: 105, y: 60.3, absolute: true },                 // [7] RIGHT-MIDDLE
  { x: 30.15, y: 105, absolute: true },                // [8] Down-MIDDLE-F
  { x: 105, y: 30.15, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod65SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 134, y: 0, absolute: true },                  // [1] top-right угол
  { x: 0, y: 134, absolute: true },                  // [2] bottom-left угол
  { x: 134, y: 134, absolute: true, hidden: true },  // [3] bottom-right угол (скрытая)
  { x: 76.1, y: 0, absolute: true, hidden: true },   // [4] TOP-MIDDLE (скрытая)
  { x: 76.1, y: 134, absolute: true },               // [5] BOTTOM-MIDDLE
  { x: 0, y: 76.1, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 134, y: 76.1, absolute: true },               // [7] RIGHT-MIDDLE
  { x: 38.05, y: 134, absolute: true },                // [8] Down-MIDDLE-F
  { x: 134, y: 38.05, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod80SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 160, y: 0, absolute: true },                  // [1] top-right угол
  { x: 0, y: 160, absolute: true },                  // [2] bottom-left угол
  { x: 160, y: 160, absolute: true, hidden: true },  // [3] bottom-right угол (скрытая)
  { x: 88.9, y: 0, absolute: true, hidden: true },     // [4] TOP-MIDDLE (скрытая)
  { x: 88.9, y: 160, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 88.9, absolute: true, hidden: true },     // [6] LEFT-MIDDLE (скрытая)
  { x: 160, y: 88.9, absolute: true },                 // [7] RIGHT-MIDDLE
  { x: 44.45, y: 160, absolute: true },                // [8] Down-MIDDLE-F
  { x: 160, y: 44.45, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod100SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 210, y: 0, absolute: true },                  // [1] top-right угол
  { x: 0, y: 210, absolute: true },                  // [2] bottom-left угол
  { x: 210, y: 210, absolute: true, hidden: true },  // [3] bottom-right угол (скрытая)
  { x: 114.3, y: 0, absolute: true, hidden: true },    // [4] TOP-MIDDLE (скрытая)
  { x: 114.3, y: 210, absolute: true },                // [5] BOTTOM-MIDDLE
  { x: 0, y: 114.3, absolute: true, hidden: true },    // [6] LEFT-MIDDLE (скрытая)
  { x: 210, y: 114.3, absolute: true },                // [7] RIGHT-MIDDLE
  { x: 57.15, y: 210, absolute: true },                // [8] Down-MIDDLE-F
  { x: 210, y: 57.15, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod125SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },      // [0] top-left угол (скрытая)
  { x: 260, y: 0, absolute: true },                  // [1] top-right угол
  { x: 0, y: 260, absolute: true },                  // [2] bottom-left угол
  { x: 260, y: 260, absolute: true, hidden: true },  // [3] bottom-right угол (скрытая)
  { x: 139.7, y: 0, absolute: true, hidden: true },  // [4] TOP-MIDDLE (скрытая)
  { x: 139.7, y: 260, absolute: true },              // [5] BOTTOM-MIDDLE
  { x: 0, y: 139.7, absolute: true, hidden: true },  // [6] LEFT-MIDDLE (скрытая)
  { x: 260, y: 139.7, absolute: true },              // [7] RIGHT-MIDDLE
  { x: 69.95, y: 260, absolute: true },                // [8] Down-MIDDLE-F
  { x: 260, y: 69.95, absolute: true },                // [9] RIGHT-MIDDLE-F
];

export const otvod150SnapPoints = [
  { x: 0, y: 0, absolute: true, hidden: true },       // [0] top-left угол (скрытая)
  { x: 313, y: 0, absolute: true },                   // [1] top-right угол
  { x: 0, y: 313, absolute: true },                   // [2] bottom-left угол
  { x: 313, y: 313, absolute: true, hidden: true },   // [3] bottom-right угол (скрытая)
  { x: 168.3, y: 0, absolute: true, hidden: true },   // [4] TOP-MIDDLE (скрытая)
  { x: 168.3, y: 313, absolute: true },               // [5] BOTTOM-MIDDLE
  { x: 0, y: 168.3, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 313, y: 168.3, absolute: true },               // [7] RIGHT-MIDDLE
  { x: 84.15, y: 313, absolute: true },                // [8] Down-MIDDLE-F
  { x: 313, y: 84.15, absolute: true },                // [9] RIGHT-MIDDLE-F
];

// ═══════════════════════════════════════════════════════════════
// ИНДИВИДУАЛЬНЫЕ ТОЧКИ ДЛЯ КАЖДОГО ПЕРЕХОДА (координаты в мм)
// ═══════════════════════════════════════════════════════════════

export const perehod483x424SnapPoints = [
  { x: 2.95, y: 0, absolute: true },                    // [1] TOP-LEFT
  { x: 45.35, y: 0, absolute: true },                   // [2] TOP-RIGHT
  { x: 0, y: 18, absolute: true },                      // [3] BOTTOM-LEFT
  { x: 48.3, y: 18, absolute: true },                   // [4] BOTTOM-RIGHT
  { x: 24.15, y: 0, absolute: true },                   // [5] TOP-MIDDLE 
  { x: 24.15, y: 18, absolute: true },                  // [6] BOTTOM-MIDDLE 
  { x: 0, y: 9, absolute: true, hidden: true },         // [7] LEFT-MIDDLE (скрытая)
  { x: 48.3, y: 9, absolute: true, hidden: true },      // [8] RIGHT-MIDDLE (скрытая)
];

export const perehod603x483SnapPoints = [
  { x: 6, y: 0, absolute: true },                       // [1] TOP-LEFT
  { x: 54.3, y: 0, absolute: true },                    // [2] TOP-RIGHT
  { x: 0, y: 37, absolute: true },                      // [3] BOTTOM-LEFT
  { x: 60.3, y: 37, absolute: true },                   // [4] BOTTOM-RIGHT
  { x: 30.15, y: 0, absolute: true },                   // [5] TOP-MIDDLE
  { x: 30.15, y: 37, absolute: true },                  // [6] BOTTOM-MIDDLE
  { x: 0, y: 18.5, absolute: true, hidden: true },      // [7] LEFT-MIDDLE (скрытая)
  { x: 60.3, y: 18.5, absolute: true, hidden: true },   // [8] RIGHT-MIDDLE (скрытая)
];

export const perehod761x603SnapPoints = [
  { x: 7.9, y: 0, absolute: true },                     // [1] TOP-LEFT
  { x: 68.2, y: 0, absolute: true },                    // [2] TOP-RIGHT
  { x: 0, y: 47, absolute: true },                      // [3] BOTTOM-LEFT
  { x: 76.1, y: 47, absolute: true },                   // [4] BOTTOM-RIGHT
  { x: 38.05, y: 0, absolute: true },                   // [5] TOP-MIDDLE
  { x: 38.05, y: 47, absolute: true },                  // [6] BOTTOM-MIDDLE
  { x: 0, y: 23.5, absolute: true, hidden: true },      // [7] LEFT-MIDDLE (скрытая)
  { x: 76, y: 23.5, absolute: true, hidden: true },     // [8] RIGHT-MIDDLE (скрытая)
];

export const perehod889x761SnapPoints = [
  { x: 6.4, y: 0, absolute: true },                     // [1] TOP-LEFT
  { x: 82.5, y: 0, absolute: true },                    // [2] TOP-RIGHT
  { x: 0, y: 38, absolute: true },                      // [3] BOTTOM-LEFT
  { x: 88.9, y: 38, absolute: true },                   // [4] BOTTOM-RIGHT
  { x: 44.45, y: 0, absolute: true },                   // [5] TOP-MIDDLE
  { x: 44.45, y: 38, absolute: true },                  // [6] BOTTOM-MIDDLE
  { x: 0, y: 19, absolute: true, hidden: true },        // [7] LEFT-MIDDLE (скрытая)
  { x: 88.9, y: 19, absolute: true, hidden: true },     // [8] RIGHT-MIDDLE (скрытая)
];

export const perehod1143x889SnapPoints = [
  { x: 12.7, y: 0, absolute: true },                    // [1] TOP-LEFT
  { x: 101.6, y: 0, absolute: true },                   // [2] TOP-RIGHT
  { x: 0, y: 77, absolute: true },                      // [3] BOTTOM-LEFT
  { x: 114.3, y: 77, absolute: true },                  // [4] BOTTOM-RIGHT
  { x: 57.15, y: 0, absolute: true },                   // [5] TOP-MIDDLE
  { x: 57.15, y: 77, absolute: true },                  // [6] BOTTOM-MIDDLE
  { x: 0, y: 38.5, absolute: true, hidden: true },      // [7] LEFT-MIDDLE (скрытая)
  { x: 114.3, y: 38.5, absolute: true, hidden: true },  // [8] RIGHT-MIDDLE (скрытая)
];

// ═══════════════════════════════════════════════════════════════
// ИНДИВИДУАЛЬНЫЕ ТОЧКИ ДЛЯ КАЖДОЙ БОРТШАЙБЫ (координаты в мм)
// ═══════════════════════════════════════════════════════════════

export const bortshaiba25SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 68, y: 0, absolute: true },                   // [2] LEFT-TOP
  { x: 17.15, y: 9, absolute: true },                // [3] LEFT-DOWN 
  { x: 50.85, y: 9, absolute: true },                // [4] RIGHT-DOWN 
  { x: 34, y: 0, absolute: true },                   // [4] TOP-MIDDLE 
  { x: 34, y: 9, absolute: true },                  // [5] BOTTOM-MIDDLE 
  { x: 0, y: 4.5, absolute: true, hidden: true },      // [6] LEFT-MIDDLE (скрытая)
  { x: 68, y: 4.5, absolute: true, hidden: true },     // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba32SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 78, y: 0, absolute: true },                   // [2] LEFT-TOP
  { x: 17.8, y: 10, absolute: true },                // [3] LEFT-DOWN 
  { x: 60.2, y: 10, absolute: true },                // [4] RIGHT-DOWN 
  { x: 39, y: 0, absolute: true },                   // [4] TOP-MIDDLE 
  { x: 39, y: 10, absolute: true },                  // [5] BOTTOM-MIDDLE 
  { x: 0, y: 5, absolute: true, hidden: true },      // [6] LEFT-MIDDLE (скрытая)
  { x: 78, y: 5, absolute: true, hidden: true },     // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba40SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 88, y: 0, absolute: true },                   // [2] RIGHT-TOP
  { x: 19.85, y: 10, absolute: true },               // [3] LEFT-DOWN
  { x: 68.15, y: 10, absolute: true },               // [4] RIGHT-DOWN
  { x: 44, y: 0, absolute: true },                   // [4] TOP-MIDDLE
  { x: 44, y: 10, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 5, absolute: true, hidden: true },      // [6] LEFT-MIDDLE (скрытая)
  { x: 88, y: 5, absolute: true, hidden: true },     // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba50SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 102, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 20.85, y: 10.5, absolute: true },             // [3] LEFT-DOWN
  { x: 81.15, y: 10.5, absolute: true },             // [4] RIGHT-DOWN
  { x: 51, y: 0, absolute: true },                   // [4] TOP-MIDDLE
  { x: 51, y: 10.5, absolute: true },                // [5] BOTTOM-MIDDLE
  { x: 0, y: 5.25, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 102, y: 5.25, absolute: true, hidden: true }, // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba65SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 122, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 22.95, y: 11, absolute: true },               // [3] LEFT-DOWN
  { x: 99.05, y: 11, absolute: true },               // [4] RIGHT-DOWN
  { x: 61, y: 0, absolute: true },                   // [4] TOP-MIDDLE
  { x: 61, y: 11, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 5.5, absolute: true, hidden: true },    // [6] LEFT-MIDDLE (скрытая)
  { x: 122, y: 5.5, absolute: true, hidden: true },  // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba80SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 140, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 25.55, y: 13, absolute: true },               // [3] LEFT-DOWN
  { x: 114.45, y: 13, absolute: true },              // [4] RIGHT-DOWN
  { x: 70, y: 0, absolute: true },                   // [4] TOP-MIDDLE
  { x: 70, y: 13, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 6.5, absolute: true, hidden: true },    // [6] LEFT-MIDDLE (скрытая)
  { x: 140, y: 6.5, absolute: true, hidden: true },  // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba100SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 158, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 21.85, y: 16, absolute: true },               // [3] LEFT-DOWN
  { x: 136.15, y: 16, absolute: true },              // [4] RIGHT-DOWN
  { x: 79, y: 0, absolute: true },                   // [4] TOP-MIDDLE
  { x: 79, y: 16, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 8, absolute: true, hidden: true },      // [6] LEFT-MIDDLE (скрытая)
  { x: 158, y: 8, absolute: true, hidden: true },    // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba125SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 184, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 22.15, y: 24, absolute: true },               // [3] LEFT-DOWN
  { x: 161.85, y: 24, absolute: true },              // [4] RIGHT-DOWN
  { x: 92, y: 0, absolute: true },                   // [4] TOP-MIDDLE
  { x: 92, y: 24, absolute: true },                  // [5] BOTTOM-MIDDLE
  { x: 0, y: 12, absolute: true, hidden: true },     // [6] LEFT-MIDDLE (скрытая)
  { x: 184, y: 12, absolute: true, hidden: true },   // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba150SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 212, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 21.85, y: 17, absolute: true },               // [3] LEFT-DOWN
  { x: 190.15, y: 17, absolute: true },              // [4] RIGHT-DOWN
  { x: 106, y: 0, absolute: true },                  // [4] TOP-MIDDLE
  { x: 106, y: 17, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 8.5, absolute: true, hidden: true },    // [6] LEFT-MIDDLE (скрытая)
  { x: 212, y: 8.5, absolute: true, hidden: true },  // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba200SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 268, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 24.45, y: 21, absolute: true },               // [3] LEFT-DOWN
  { x: 243.55, y: 21, absolute: true },              // [4] RIGHT-DOWN
  { x: 134, y: 0, absolute: true },                  // [4] TOP-MIDDLE
  { x: 134, y: 21, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 10.5, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 268, y: 10.5, absolute: true, hidden: true }, // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba250SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 321, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 24, y: 21, absolute: true },                  // [3] LEFT-DOWN
  { x: 297, y: 21, absolute: true },                 // [4] RIGHT-DOWN
  { x: 160.5, y: 0, absolute: true },                // [4] TOP-MIDDLE
  { x: 160.5, y: 21, absolute: true },               // [5] BOTTOM-MIDDLE
  { x: 0, y: 10.5, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 321, y: 10.5, absolute: true, hidden: true }, // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba300SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 370, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 23.05, y: 21, absolute: true },               // [3] LEFT-DOWN
  { x: 346.92, y: 21, absolute: true },              // [4] RIGHT-DOWN
  { x: 185, y: 0, absolute: true },                  // [4] TOP-MIDDLE
  { x: 185, y: 21, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 10.5, absolute: true, hidden: true },   // [6] LEFT-MIDDLE (скрытая)
  { x: 370, y: 10.5, absolute: true, hidden: true }, // [7] RIGHT-MIDDLE (скрытая)
];

export const bortshaiba350SnapPoints = [
  { x: 0, y: 0, absolute: true },                    // [1] LEFT-TOP
  { x: 422, y: 0, absolute: true },                  // [2] RIGHT-TOP
  { x: 33.2, y: 20, absolute: true },                // [3] LEFT-DOWN
  { x: 388.8, y: 20, absolute: true },               // [4] RIGHT-DOWN
  { x: 211, y: 0, absolute: true },                  // [4] TOP-MIDDLE
  { x: 211, y: 20, absolute: true },                 // [5] BOTTOM-MIDDLE
  { x: 0, y: 10, absolute: true, hidden: true },     // [6] LEFT-MIDDLE (скрытая)
  { x: 422, y: 10, absolute: true, hidden: true },   // [7] RIGHT-MIDDLE (скрытая)
];

